<template>
  <div v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': isFocus,'visible-onlyValue': defaultData && defaultData.length > 0}" class="table-select-box participant" style="padding-right: 16px;">
    <el-popover  ref="popover" placement="bottom" trigger="click" v-model="isFocus" :disabled="readonly">
      <div slot="reference">
        <div class="task-participant" v-if="defaultData && defaultData.length > 0">
            <div class="avatar-parent-box">
              <div class="avatar-parent-flex table-parent-pop">
                <Myavatar width="28px" height="28px" size="12" v-for="m in (tableShowNumber > 0 ? defaultData.slice(0, tableShowNumber) : defaultData) " :userName="m.realname" :imgUrl="m.user_avatar" :key="m.uid">
              </Myavatar>
                <div class="more-box-tip" v-if="tableShowNumber > 0">
                  <i class="icon iconfont iconicon_more_task1"></i>
                </div>
              </div>
            </div>
        </div>
        <p v-else class="table-select-button">
          <span v-if="readonly">暂无</span>
          <span v-else><i class="el-icon-circle-plus"></i>添加</span>
        </p>
      </div>
      <ParticipantList v-if="isFocus" v-model="defaultData" @close="close" @confirm="slecetVaule" :delArr="delArr" :tagList="tagList"></ParticipantList>
    </el-popover>
  </div>
  <div v-else-if="(value && value.length > 0) || !readonly" class="Participant" ref="participant" :class="{'hover-style-rest':readonly}" style="padding:0;">
    <el-popover  ref="popover" placement="bottom" trigger="click" v-model="isFocus" :disabled="readonly || isTemplate">
      <div slot="reference">
        <div class="task-participant hover-style" v-if="defaultData && defaultData.length > 0">
          <!-- <toolTip class="hover-style" :title="defaultData ? defaultData.map(res => res.realname).filter(res => res).join('，') : ''" :show="showNumber > 0"> -->
            <div class="avatar-parent-box">
              <div class="avatar-parent-flex">
                <Myavatar width="28px" height="28px" size="12" v-for="m in  (showNumber > 0 ? defaultData.slice(0, showNumber) : defaultData)" :userName="m.realname" :imgUrl="m.user_avatar" :key="m.uid"></Myavatar>
                <div class="more-box-tip" v-if="showNumber > 0">
                  <i class="icon iconfont iconicon_more_task1"></i>
                </div>
              </div>
            </div>
          <!-- </toolTip> -->
        </div>
        <div v-else :class="{'show-txt-rest': readonly}">
          <span class="add-txt" :class="{'disabled': isTemplate}">添加</span>
        </div>
      </div>
      <ParticipantList v-if="isFocus" v-model="defaultData" @close="close" @confirm="slecetVaule" :delArr="delArr" :tagList="tagList"></ParticipantList>
    </el-popover>
  </div>

</template>

<script>
import ParticipantList from "./participantList"
import { mapActions, mapState, mapGetters } from 'vuex';
import elementResizeDetectorMaker from 'element-resize-detector'
import api from '@/services/api/project/project'
export default {
  name: "TaskParticipant",
  components: {
    ParticipantList
  },
  props: ['value', 'projectId', 'defaultValue', 'onlyValue', 'item', 'getketText', 'readonly', 'width', 'isTemplate', 'isTags'],
  data() {
    return {
      isFocus: false,
      defaultData: [],
      erd: '',
      showNumber: 0,
      boxInWidth: 0,
      delArr: [],
      tagList: []
    }
  },
  created() {
  },
  mounted() {
    this.init()
  },
  watch: {
    defaultData: {
      handler() {
        if(!this.onlyValue) {
          if (!this.erd && this.$refs['participant']) {
            this.erd = elementResizeDetectorMaker();
            this.erd.listenTo(this.$refs['participant'], this.watchWidth)
          }
          this.watchWidth()
        }
      },
      deep: true
    },
    isFocus() {
      if (this.isFocus) {
        this.getTags()
      }
    }
  },
  computed: {
    ...mapState('project/project', {
      newMember: state => state.newMember
    }),
    tableShowNumber() {
      let width = this.width - 48
      let number = Math.floor(width / 20)
      return number >= this.defaultData.length ? 0 : number - 1
    }
  },
  methods: {
    ...mapActions('task/task', ['updatetasktmember']),
    ...mapActions('project/project', ['getNewProjectMember']),
    async getTags() {
      let result = await api.projectTagList({ project_id: this.projectId, page: 1, per_page: 9999 })
      this.$set(this, 'tagList', result.data)
      this.$nextTick(() => {
        this.$refs.popover.updatePopper()
      })
    },
    watchWidth() {
      this.$nextTick(() => {
        if (!this.$refs.participant) return
        let box = this.$refs.participant.offsetWidth
        let boxIn = this.defaultData.length * 30
        this.boxInWidth = boxIn
        if (this.boxInWidth - box > 0) {
          this.showNumber = Math.floor((box - 16) / 30) - 1
        } else {
          this.showNumber = 0
        }
      })
    },
    slecetVaule(val) {
      this.$emit('input', val ? val.map(res => res.uid) : [])
      this.setDataList(val)
      this.close();
      this.$nextTick(() => {
        this.$emit('change', val)
      })
    },
    setDataList(val) {
      if (val) {
        this.defaultData = JSON.parse(JSON.stringify(val))
      } else {
        let arr = []
        this.newMember.map(res => arr.push(...res.children))
        this.defaultData = this.defaultValue.map(res => {
          return {
            ...res,
            ...res.user
          }
        })
        this.delArr = this.defaultData.concat(arr).filter(v => !(arr.find(res => res.uid === v.uid))) // 删除集合
      }
    },
    init() {
      if (this.defaultValue && this.defaultValue.length > 0) {
        let defaultValue = this.getDefaultValue(this.defaultValue)
        this.$emit('input', defaultValue)
        this.setDataList()
      }
    },
    getMessage(res, item) {
      if (res.add_data.length > 0 && res.delete_data.length > 0) {
        return `
            <span class="message-mixin-tip">将${res.field_name}修改为</span>
            <span class="message-mixin-task">${res.add_data.map(res => res.realname).join('、')}</span>
            <span class="message-mixin-tip">移除了</span>
            <span class="message-mixin-task">${res.delete_data.map(res => res.realname).join('、')}</span>
            `
      } else if (res.add_data.length > 0) {
        return `
            <span class="message-mixin-tip">将${res.field_name}修改为</span>
            <span class="message-mixin-task">${res.add_data.map(res => res.realname).join('、')}</span>`
      } else if (res.delete_data.length > 0) {
        return `
            <span class="message-mixin-tip">将${res.field_name}移除了</span>
            <span class="message-mixin-task">${res.delete_data.map(res => res.realname).join('、')}</span>`
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val.map(res => res.component_value)
      }
    },
    close() {
      this.isFocus = false
    },
    getBlur() {
      this.isFocus = true
    },
    tileData(dataList) {
      let arr = [];
      dataList.forEach(item => {
        arr = [...arr, ...item.member];
      });
      return arr;
    },
    clearData() {
      this.slecetVaule([])
    },
  }
}
</script>

<style lang="scss" scoped>
.Participant {
  width: 100%;
  & > span {
    display: block;
    width: 100%;
  }
  .more-box-tip {
    width: 28px;
    height: 28px;
    background: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 28px;
    flex-shrink: 0;
    box-sizing: border-box;
    border: 1px solid rgba(32,32,32,0.08);
  }
  .task-participant {
    // display: flex;
    // align-items: center;
    // padding-left: 8px;
  }
  .hover-style {
    height: 40px;
  }
  &:hover {
    .add-icon {
      visibility: visible;
    }
  }
  .add-icon {
    text-align: center;
    border-radius: 50%;
    visibility: hidden;
  }
  .avatar-box {
    padding: 0 1px;
  }
  .only-value {
    width: 150px;
    display: flex;
    flex-wrap: wrap;
  }
  .avatar-parent-box {
    display: inline-block;
    .avatar-parent-flex {
      display: flex;
    }
    .table-parent-pop {
      > .avatar-box:not(:first-child) {
        margin-left: -8px;
      }
      >.more-box-tip {
        margin-left: -8px;
        position: relative;
        z-index: 99;
      }
    }
  }
}
</style>

